import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { isNullOrUndefined } from 'is-what';
import { AccountDto } from '../../../data/models/account-dto';
import { CcLineSummaryDto } from '../../../data/models/cc-line-summary-dto';
import { LineDetailsDto } from '../../../data/models/line-details-dto';
import { LineFullInfoDto } from '../../../data/models/line-full-info-dto';
import { AccountService } from '../../../services/account.service';
import { GlobleVariables } from '../../../services/app.service';
import { AuthService } from '../../../services/auth.service';
import { CommonGlobalService } from '../../../services/common-global.service';
import { LineDetailsService } from '../../../services/line-details.service';
import { authenticationEnum } from '../../shared/layout/menu-sidebar/menu-sidebar.component';

@Component({
  selector: 'app-cc-portal',
  templateUrl: './cc-portal.component.html',
  styleUrls: ['./cc-portal.component.scss'],
  providers: [MessageService]
})
export class CcPortalComponent implements OnInit {

  lineId: number;
  //fullLineInfo: LineFullInfoDto;
  fullLineInfo: CcLineSummaryDto;
  parentFullLineInfo: CcLineSummaryDto;

  firstLineOfAccount: LineDetailsDto;
  accountLinesExist: boolean = false;
  startRendering: boolean = false;
  accountLinesList: LineDetailsDto[] = [];
  breadItems: MenuItem[];

  isPair: boolean = false;

  lineNotBelongsTaAccount = false;
  isGettingPairParent: boolean = false;

  constructor(private elementRef: ElementRef, private messageService: MessageService, private lineDetailsService: LineDetailsService
    , private activatedRoute: ActivatedRoute, private authService: AuthService, private accountService: AccountService,
    private commonGlobalService: CommonGlobalService) { }

  ngOnInit() {

    this.checkUrlToGetCode();
    this.breadItems = [
      { label: 'Home', routerLink: '/' },
      { label: 'Line Details' },
      { label: 'Map & Tickets', icon: 'pi pi-map-marker', command: () => { this.scrollToMap() } }
    ];

  }


  checkUrlToGetCode() {
   this.activatedRoute.params.subscribe(
      (params) => {
        let tmplineId = params["lineId"];
        if (tmplineId) {
          this.lineId = tmplineId;
          this.getLineInfo(this.lineId);
        }
        else {
          // this.lineId = 135444;
          //this.getLineInfo(135444);
          //there is no line Id 
          this.messageService.add({ severity: 'error', summary: 'Line Id not retrieved', detail: 'unable to show page contents' });
          }
          return;
      });
  }



  getLineInfo(lineID) {
    this.lineDetailsService.getLineDetails(lineID).subscribe(
      (response: CcLineSummaryDto) => {
        if (!isNullOrUndefined(response.id) && !isNullOrUndefined(response.ucid) && !isNullOrUndefined(response.quoteID)) {
          this.lineNotBelongsTaAccount = false;

          if (!this.isGettingPairParent) {
            this.fullLineInfo = response;
            this.fullLineInfo.fakeName = this.fullLineInfo.name?.slice(0, this.fullLineInfo.name?.indexOf('.')) + "." + this.fullLineInfo.quoteID;
            if (response.pairNum && response.pairNum > 0) {
              this.isPair = true;
              this.isGettingPairParent = true;
              this.fullLineInfo.fakeName += ".(Pair" + this.fullLineInfo.pairNum + ")";
              this.fullLineInfo.fakeName = "Bundle--" + this.fullLineInfo.fakeName;
            }
            else {
              this.isPair = false;
              this.isGettingPairParent = false;
            }
            (this.isPair && this.isGettingPairParent) ? this.getLineInfo(this.fullLineInfo.parentID) /*this.checkGetParentOrNot()*/ : this.startRendering = true;
          }
          else {
            this.parentFullLineInfo = response;
            this.parentFullLineInfo.fakeName = "Bundle--"+this.parentFullLineInfo.name?.slice(0, this.parentFullLineInfo.name?.indexOf('.')) + "." + this.parentFullLineInfo.quoteID + ".(Pair" + this.fullLineInfo.pairNum + ")";
            this.startRendering = true;
            this.isGettingPairParent = false;
            (this.isPair && this.isGettingPairParent) ? this.getLineInfo(this.fullLineInfo.parentID) /*this.checkGetParentOrNot()*/ : this.startRendering = true;
          }
         // (this.isPair && this.isGettingPairParent) ? this.getLineInfo(this.fullLineInfo.parentID) /*this.checkGetParentOrNot()*/ : this.startRendering = true;
        }

        else {
          this.messageService.add({ severity: 'error', summary: 'Line Basic Details', detail: 'retrieving line information returned nothing' });
          this.lineNotBelongsTaAccount = true;
        }
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Line Basic Details', detail: 'retrieving line information returned error' });
      }
    );
  }


  checkGetParentOrNot() {
    if (this.isPair) {
      this.getLineInfo(this.fullLineInfo.parentID);
    }
  }

  scrollToMap() {
    const element = this.elementRef.nativeElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }

}
